<template>
  <div>
    <el-dialog :title="title" :visible.sync="isShowModal" :close-on-click-modal="false" width="900px"
               @close="closeDialog">
      <div style="text-align: right; position: absolute; top:20px; right: 100px;">
        <el-button v-print="'#printMe'" icon="el-icon-printer" type="primary">打印</el-button>
      </div>
      <div style="width: 800px; height: 600px; overflow-y: scroll; border: 1px solid #ccc; margin: 0 auto;">
        <div id="printMe"
             style=" width: 700px; margin: 0 auto; height: 1000px;">
          <div class="stuBox" style="page-break-after:always;">

            <div class="title flexCloumnSingleCenter">
              <div class="FS18 bold" style="line-height: 50px;">学生携带手机进校园申请表</div>
            </div>
            <div class="table">
              <el-row class="borderR">
                <el-col :span="4" class="cell cell50">系部</el-col>
                <el-col :span="8" class="cell cell50">{{ detailInfo.department }}</el-col>
                <el-col :span="4" class="cell cell50">班级</el-col>
                <el-col :span="8" class="cell cell50">{{ detailInfo.class }}</el-col>
              </el-row>
              <el-row class="borderR">
                <el-col :span="4" class="cell cell50">学生姓名</el-col>
                <el-col :span="4" class="cell cell50">{{ detailInfo.stuName }}</el-col>
                <el-col :span="4" class="cell cell50">是否团员</el-col>
                <el-col :span="4" class="cell cell50">{{ detailInfo.istuanyuan == 1 ? '是' : '否' }}</el-col>
                <el-col :span="4" class="cell cell50">是否住宿</el-col>
                <el-col :span="4" class="cell cell50">{{ detailInfo.isdorm == 1 ? '是' : '否' }}</el-col>
              </el-row>
              <el-row class="borderR">
                <el-col :span="4" class="cell cell50">手机型号</el-col>
                <el-col :span="8" class="cell cell50">{{ detailInfo.phoneType }}</el-col>
                <el-col :span="4" class="cell cell50">手机号码</el-col>
                <el-col :span="8" class="cell cell50">{{ detailInfo.phone }}</el-col>
              </el-row>
              <el-row class="cell cell50 borderR">手机带入学校申请原因陈述</el-row>

              <el-row class="cell borderR">
                <el-row class="" style="padding: 10px;min-height: 200px;">{{detailInfo.remark}}</el-row>
                <el-row class="flexEnd">
                  <el-col :span="4" class="cell50 flexEnd">监护人签名:</el-col>
                  <el-col :span="6" class="cell50 flexCenter">
                    <div class="flexCenter" style="width: 100%;min-height: 80px;box-sizing:border-box;padding:1px;">
                      <img v-if="detailInfo.signUrl" :src="detailInfo.signUrl" alt="" style="width: 100%;">
                    </div>
                  </el-col>
                </el-row>
                <el-row class="flexEnd">
                  <el-col :span="4" class="cell50 flexEnd">申请日期:</el-col>
                  <el-col :span="6" class="cell50 flexCenter">{{baseInfo.cdate.substr(0,10)}}
                  </el-col>
                </el-row>
              </el-row>

              <el-row class="cell borderR">
                <el-row class="">
                  <el-col :span="1" class="cell50"></el-col>
                  <el-col :span="6" class="cell50 flexStart">班主任意见:</el-col>
                </el-row>
                <el-row class="">
                  <el-col :span="18" class="cell50 flexEnd">班主任签名:</el-col>
                </el-row>
              </el-row>

              <el-row class="cell borderR ">
                <el-row class="">
                  <el-col :span="1" class="cell50"></el-col>
                  <el-col :span="6" class="cell50 flexStart">系部意见:</el-col>
                </el-row>
                <el-row class="">
                  <el-col :span="18" class="cell50 flexEnd">系部负责人签名:</el-col>
                </el-row>
              </el-row>
              <el-row class="borderR borderB">
                <el-col :span="4" class="cell cell50">备注</el-col>
                <el-col :span="20" class="cell cell50"></el-col>
              </el-row>
            </div>

          </div>

        </div>

      </div>

    </el-dialog>
  </div>
</template>

<script>

export default {


  props: {
    detailInfo:{
      name: "",
      gender: 0
    },
    baseInfo:{
      type: Object,
      default:{},
    },
    dialogNum:0,
    title:'',
  },
  data() {
    return {
      isShowModal: true,
    }
  },
  mounted() {

  },
  methods: {
    closeDialog() {
      this.$parent.closePrint()
    }
  }
}
</script>

<style scoped="scoped" type="text/less" lang="less">
.flexStretch{
  display: flex;justify-content: flex-start;align-items: stretch;
}
.stuBox{
  box-sizing: border-box;
  padding-top: 20px;
  position: relative;
  .posIndex{
    position: absolute;
    top: 20px;
    right: 0px;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    border: 2px solid #303133;
  }
  .table{
    width: 100%;
  }
  .borderR {border-right: 1px solid #333;}
  .borderB {border-bottom: 1px solid #333;}
  .FS18{
    font-size: 18px;
  }
  .bold{
    font-weight: 700;
    font-family: Avenir, Helvetica, Arial, sans-serif;
  }
  .cell{
    border-left: 1px solid #333;
    border-top: 1px solid #333;

    min-height: 30px;
    line-height: 30px;
    text-align: center;
    white-space: nowrap;
    font-size: 14px;
    font-family:"宋体";
  }
  .cell50{
    min-height: 50px;
    line-height: 50px;
    font-size: 14px;
    font-family:"宋体";
  }
  .cellMore{
    border-left: 1px solid #333;
    border-top: 1px solid #333;
    min-height: 50px;
    text-align: left;
    font-size: 14px;
    font-family:"宋体";
  }
}
.uline {
  text-decoration: underline;
}
</style>
